<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="px-4 pb-20">
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <flash-messages />
        <div class="px-4 gap-4">
          <h3
            class="text-xl text-brand-blue-400 font-display uppercase justify-center md:justify-start mb-4"
          >
            Send an invitation
          </h3>
          <p class="mb-4">
            To send an invitation to complete a Fleet Risk Review enter the invitee's
            email address and click the "Send Invitation" button.
          </p>
          <div class="flex flex-wrap w-full">
            <div class="w-1/4">
              <label for="email" class="font-semibold text-brand-blue-400">Email</label>
            </div>
            <div class="w-3/4">
              <input
                class="border border-gray-300 px-2 py-1 w-full"
                id="email"
                type="text"
                v-model="form.email"
                autocomplete="off"
              />
            </div>
            <template v-if="$attrs.errors.email">
              <div
                v-if="$attrs.errors.email.startsWith('An invitation was already')"
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
              >
                {{ $attrs.errors.email }}
                If you would like to send them a reminder go
                <Link href="/admin/reminders">here</Link>.
              </div>
              <div
                v-else
                class="border-2 border-red-500 bg-red-300 w-full px-2 py-1 text-gray-900 text-sm"
              >
                {{ $attrs.errors.email }}
              </div>
            </template>
          </div>
          <div class="flex justify-end w-full mt-4">
            <button
              class="bg-brand-green-400 hover:bg-brand-green-200 text-white font-bold py-2 px-4 rounded justify-right uppercase disabled:cursor-not-allowed disabled:hover:bg-brand-green-400"
              :disabled="form.email === ''"
              @click="
                form.post('/admin/invitations', {
                  preserveScroll: true,
                  preserveState: true,
                  onSuccess: () => {
                    form.reset();
                  },
                })
              "
            >
              Send invitation
            </button>
          </div>
        </div>
      </div>
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <h3
          class="text-xl text-brand-blue-400 font-display uppercase justify-center md:justify-start mb-4"
        >
          Recent invitations
        </h3>
        <div v-if="invitations.length > 0" class="table w-full">
          <div class="table-header-group">
            <div class="table-row">
              <div
                class="table-cell font-display font-semibold text-brand-blue-400 uppercase"
              >
                Email
              </div>
              <div
                class="table-cell font-display font-semibold text-brand-blue-400 uppercase"
              >
                Invited at
              </div>
            </div>
          </div>
          <div class="table-row-group">
            <div v-for="invitation in invitations" class="table-row" :key="invitation.id">
              <div class="table-cell">{{ invitation.email }}</div>
              <div class="table-cell">
                {{ $moment(invitation.created_at).format("DD MMM YYYY HH:mm") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import { Inertia } from "@inertiajs/inertia";
import Layout from "@/Shared/Layouts/Admin/Layout";
import { useForm } from "@inertiajs/inertia-vue3";
import FlashMessages from "@/Shared/FlashMessages";

export default {
  components: {
    PageHeader,
    FlashMessages,
  },
  layout: Layout,
  methods: {
    onDeleteInvitation(invitationId) {
      Inertia.delete("/admin/invitations/" + invitationId, { preserveScroll: true });
    },
  },
  name: "Admin-Invitations",
  props: {
    invitations: {
      default: [],
      required: true,
      type: Array,
    },
  },
  setup() {
    const form = useForm({
      email: "",
    });
    const headingContent = {
      hero: {
        image: "/images/263918963_cars_hero.jpg",
        title: "Fleet Risk Review",
        subtitle: "In association with AXA Insurance",
      },
      page: {
        title: "New Invitations",
        subtitle: "",
      },
    };

    return {
      form,
      headingContent,
    };
  },
};
</script>
